import React from "react";
import { WindowBlack } from "../styles/home";
import { Cells, Experience, Resume } from "../styles/about";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import SchoolIcon from "@mui/icons-material/School";
import experiences from "../data/experience.json";
import education from "../data/education.json";

const ResumeSection = () => {
  return (
    <WindowBlack>
      <Resume>
        <Experience>
          <h2>Experience</h2>
          {experiences.map((exp) => (
            <Cells>
              <div className="icon">
                <WorkOutlineIcon fontSize="large" sx={{ color: "orange" }} />
              </div>
              <div>
                <p>{exp.period}</p>
                <h3>{exp.title}</h3>
                <p>{exp.company}</p>
              </div>
            </Cells>
          ))}
        </Experience>
        <Experience>
          <h2>Education</h2>
          {education.map((edu) => (
            <Cells>
              <div className="icon">
                <SchoolIcon fontSize="large" sx={{ color: "orange" }} />
              </div>
              <div>
                <p>{edu.period}</p>
                <h3>{edu.title}</h3>
                <p>{edu.organization}</p>
              </div>
            </Cells>
          ))}
        </Experience>
      </Resume>
    </WindowBlack>
  );
};

export default ResumeSection;
